<script setup lang="ts">
import { computed } from 'vue'

import type { StatusProps } from './types'
import { statusVariants } from './variants'
import { clsx } from 'clsx'
import { Primitive } from 'radix-vue'

const props = defineProps<StatusProps>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <Primitive
    data-slot="badge"
    :class="
      clsx(statusVariants({ variant, position, padding, width }), props.class)
    "
    v-bind="delegatedProps"
  >
    <slot />
  </Primitive>
</template>
